/** @file Events panel body: event list by name, the selected event's defaults and its keys. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import { useState } from 'react';
import { freshName } from '../rigKit/freshName';
import { listHandlers } from '../rigKit/listHandlers';
import { NamedList } from '../rigKit/NamedList';
import type { RigView } from '../rigKit/rigView';
import { EventDefaults } from './EventDefaults';
import { EventKeys } from './EventKeys';

/** event.create (fresh `event-<n>` name), event.rename, event.delete, event.setDefaults; keys below. */
export function EventsView(view: RigView) {
  const { doc, t, run } = view;
  const [picked, setPicked] = useState<string | null>(null);
  const events = entriesByName(doc.events);
  const event = picked === null ? undefined : doc.events[picked];
  const create = (): void => { run([{ name: 'event.create', input: { name: freshName('event', events.map(([, e]) => e.name)) } }]); };
  return (
    <div className="rig-body">
      <NamedList t={t} label={t('panels.events.title')} rows={events.map(([id, e]) => ({ id, name: e.name }))} selected={event === undefined ? null : picked}
        onSelect={setPicked} onCreate={create} {...listHandlers('event', run)} />
      {picked !== null && event !== undefined && (
        <>
          <EventDefaults t={t} event={event} onChange={(value) => { run([{ name: 'event.setDefaults', input: { target: picked, value } }]); }} />
          <EventKeys view={view} event={picked} />
        </>
      )}
    </div>
  );
}
